import React, { useContext, useState } from "react";
import Popover from "@mui/material/Popover";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

import Button from "components/UI/Button";
import { useIntlHelper } from "hooks";
import {
  plusBlue,
  library,
  externalLink,
  addCustomWidget,
  arrowDown,
} from "assets/icons";
import {
  foundationNames,
  priceOptimizationNames,
  inventoryOptimizationNames,
} from "../../../../../../utils/utilsDashboard";

import DialogNewSubItemMenuName from "./DialogNewSubItemMenuName";
import Context from "../../../Context";

import "./styles.scss";

type SubItemMenu = {
  id: number;
  label: string;
  new: boolean;
};

type AddButtonProps = {
  style: {
    [key: string]: any;
  };
  menuItems: {
    id: number;
    label: string;
    new: boolean;
  }[];
  newParentName: string;
  setSubMenuName: React.Dispatch<
    React.SetStateAction<SubItemMenu | string | null>
  >;
  setNewSubItemMenuName: (v: string) => void;
  setStep: (v: number) => void;
};

const AddButton: React.FC<AddButtonProps> = ({
  style = {},
  menuItems = [],
  newParentName,
  setSubMenuName,
  setNewSubItemMenuName,
  setStep,
}) => {
  const { parentMenu } = useContext(Context);

  const [anchorElSelectParentMenu, setAnchorElSelectParentMenu] =
    useState(null);

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [customItemName, setCustomItemName] = useState("");

  const { getIntlMessage } = useIntlHelper();

  const getItems = (): any[] => {
    if (newParentName == "Foundation") {
      const missingItems = foundationNames.filter(
        (item: any) =>
          !parentMenu[0].submenus.some((menu) => menu.name === item)
      );
      // return foundationNames;
      return missingItems;
    }

    if (newParentName == "Price Optimization") {
      const missingItems = priceOptimizationNames.filter(
        (item: any) =>
          !parentMenu[1].submenus.some((menu) => menu.name === item)
      );
      // return priceOptimizationNames;
      return missingItems;
    }

    if (newParentName == "Inventory Optimization") {
      const missingItems = inventoryOptimizationNames.filter(
        (item: any) =>
          !parentMenu[2].submenus.some((menu) => menu.name === item)
      );
      // return inventoryOptimizationNames;
      return missingItems;
    }

    return [""];
  };

  const codingName = () => {
    return newParentName == "Foundation"
      ? "1§"
      : newParentName == "Price Optimization"
      ? "2§"
      : newParentName == "Inventory Optimization"
      ? "3§"
      : "";
  };

  const handleCustomItemSubmit = () => {
    if (customItemName.trim()) {
      selectParentMenuItem(codingName() + customItemName.trim());
      setCustomItemName("");
      handleCloseSelectParentMenu();
    }
  };

  const handleClickSelectParentMenu = (event: any) => {
    setAnchorElSelectParentMenu(event.currentTarget);
  };

  const handleCloseSelectParentMenu = () => {
    setAnchorElSelectParentMenu(null);
  };

  const selectParentMenuItem = (item: any) => {
    setSubMenuName(item);
    setNewSubItemMenuName(item);
    setStep(2);
  };

  const openManageNewParentMenuNameModal = () => {
    setIsDialogOpen(true);
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
  };

  const createSubItemMenuView = () => {
    return (
      // <div style={style} className='select-parent-menu-widget-wrapper'>
      //   <Button
      //     id="add-widget-button"
      //     variant='text'
      //     className='select_parent_menu_widget_btn'
      //     aria-haspopup="true"
      //     onClick={openManageNewParentMenuNameModal}
      //   >
      //     <img
      //       src={plusBlue}
      //       alt="add new widget"
      //     />
      //     <h3 style={{paddingLeft:'10px'}}>Create a Dashboard Name</h3>
      //   </Button>

      //   <DialogNewSubItemMenuName
      //     open={isDialogOpen}
      //     onClose={closeDialog}
      //     setSubMenuName={setSubMenuName}
      //     setNewSubItemMenuName={setNewSubItemMenuName}
      //     setStep={setStep}
      //     isEditMode={false}
      //     getIntlMessage={getIntlMessage}
      //   />

      // </div>

      <div style={style} className="select-parent-menu-widget-wrapper">
        <Button
          id="add-widget-button"
          variant="text"
          className="select_parent_menu_widget_btn"
          aria-controls={openSelectParentMenu ? "options-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={openSelectParentMenu ? "true" : undefined}
          onClick={handleClickSelectParentMenu}
        >
          <h3 className="select_parent_menu_widget_btn_text">
            {getIntlMessage("create_or_select_a_dashboard_name")}
          </h3>
          <img src={arrowDown} alt="add new widget" />
        </Button>

        <Popover
          id={idParentMenu}
          open={openSelectParentMenu}
          anchorEl={anchorElSelectParentMenu}
          onClose={handleCloseSelectParentMenu}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <Box sx={{ backgroundColor: "#0C1B3B" }}>
            <Box sx={{ px: 2, py: 1 }}>
              <TextField
                variant="standard"
                placeholder="Custom name"
                value={customItemName}
                onChange={(e) => setCustomItemName(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleCustomItemSubmit();
                  }
                }}
                fullWidth
                InputProps={{
                  disableUnderline: false,
                  sx: {
                    color: "#FFFFFF",
                    borderBottom: "1px solid #1DA1F2",
                    "&::placeholder": {
                      color: "#AAB8C2",
                    },
                    "&:hover:not(.Mui-disabled):before": {
                      borderBottom: "1px solid #1DA1F2",
                    },
                    "&.Mui-focused:before": {
                      borderBottom: "1px solid #1DA1F2",
                    },
                    "&.Mui-focused:after": {
                      borderBottom: "1px solid #1DA1F2",
                    },
                  },
                }}
                sx={{
                  backgroundColor: "transparent",
                  input: { color: "#FFFFFF" },
                }}
              />
            </Box>
            <MenuList className="options-menu">
              {getItems().map((item, index) => (
                <MenuItem
                  key={index}
                  onClick={() => selectParentMenuItem(item)}
                >
                  {item}
                </MenuItem>
              ))}
            </MenuList>
          </Box>
        </Popover>
      </div>
    );
  };

  const openSelectParentMenu = Boolean(anchorElSelectParentMenu);
  const idParentMenu = openSelectParentMenu ? "simple-popover" : undefined;

  const { isEditMode } = useContext(Context);
  if (!isEditMode) {
    return <></>;
  }

  return <>{createSubItemMenuView()}</>;
};

export default AddButton;
